<!-- 辅导信息 -->
<template>
  <div class="project-info">
    <!-- 头部 -->
    <div class="project-info-top">
      <div class="project-info-top-detail">
        <!-- 信息 -->
        <coach-detail></coach-detail>
      </div>
      <div class="project-info-top-menu">
        <!-- 导航 -->
        <coach-menu></coach-menu>
      </div>
    </div>
    <!-- 内容 -->
    <div class="project-info-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// components
import CoachDetail from './components/coach-info-detail'
import CoachMenu from './components/coach-info-menu'
export default {
  name: 'project-coach-info',
  components: {
    CoachDetail,
    CoachMenu
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
